import { Component, OnInit, Input } from '@angular/core';
import { Activity, Activitykpi, Project } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SortDirection } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/';
import { forkJoin } from 'rxjs';
import { ActivitykpiEditComponent } from '../activitykpi-edit/activitykpi-edit.component';
import { DialogService } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-activitykpi-list',
	templateUrl: './activitykpi-list.component.html',
	styleUrls: ['./activitykpi-list.component.scss']
})
export class ActivitykpiListComponent implements OnInit {

	@Input()
	activityid: number;

	@Input()
	projectid: number;
	project: Project;

	loading: boolean = false;
	rows: Activitykpi[] = [];

	advancedSearch: Search = new Search('activitykpi', 'name', 'activitykpi');

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	constructor(
		private kpiService: CrudService<Activitykpi>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private projectService: CrudService<Project>,
		private modalService: NgbModal
	) {
		this.advancedSearch.setSortDirection(SortDirection.DESCENDING);
		this.advancedSearch.setSortField('id');
	}

	ngOnInit() {
		this.load();

		if (this.projectid) {
			this.projectService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => this.project = p);
		}
	}

	load(): void {

		this.loading = true;
		this.rows = [];

		if (this.activityid) {
			this.advancedSearch.addSimpleFilter('activityid', this.activityid);
		}

		const datarequest = this.kpiService.searchEntities(Activitykpi, 'activitykpi', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.kpiService.countEntities(Activitykpi, 'activitykpi', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.load();
	}

	edit(activitykpiid: number): void {
		const modal = this.modalService.open(ActivitykpiEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.activityid = this.activityid;
		modal.componentInstance.load(activitykpiid);

		modal.result.then(() => {
			this.load();
		}).catch(() => { });
	}

	delete(activitykpi: Activitykpi, event: any): void {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-activitykpi-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.kpiService.deleteEntity(Activitykpi, 'activitykpi', activitykpi).subscribe(() => {
					this.translateService.get(['labels.activitykpi-deleted', 'labels.activitykpis']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.activitykpi-deleted'], messages['labels.activitykpis']);
						this.load();
					});
				});
			}
		});
	}

}
